module.exports = __webpack_public_path__ + "img/img3.a35a33ff.png";